import { useDispatch } from 'react-redux';
import { Trans } from '@lingui/react';
import cn from 'classnames';

import {
  CHANGE_WALLET,
  DISCONNECT_WALLET,
  useAnalytics,
} from '../../../shared/analytics';
import { useDialog } from '../../../shared/context';
import { userSlice } from '../../../shared/redux/slices';

import styles from './HeaderDropdown.module.scss';
import { useUserLogout, useUserTelegramAuth } from '../../eco-drops/hooks/user';
import { useEffect, useState } from 'react';
import { TelegramUser } from '../../eco-drops/hooks/types';
import { useEcoDropsStore } from '../../../shared/zustand/ecoDropsStore';

type HeaderSelectProps = {
  children: JSX.Element;
  className?: string;
};

export function HeaderDropdown({
  children,
  className,
}: HeaderSelectProps): JSX.Element {
  const setUserStore = useEcoDropsStore((s) => s.setUser);

  const dispatch = useDispatch();
  const { sendEvent } = useAnalytics();
  // const { signer, address, signature, signTypedData, loading, error } =
  //   useTypedDataSignature(DOMAIN, TYPES);

  // const { mutate: onAuthUser } = useUserAuth();
  const { mutateAsync: onLogout } = useUserLogout();
  const { openDialog } = useDialog();

  const handleDisconnect = (): void => {
    sendEvent(DISCONNECT_WALLET);
    dispatch(userSlice.actions.disconnectWallet());
    setUserStore(null);
    onLogout();
  };

  const handleChangeWallet = (): void => {
    sendEvent(CHANGE_WALLET);
    openDialog('ConnectWallet');
  };

  return (
    <div className={cn(styles.root, className)}>
      {children}
      <div className={styles.walletOptions}>
        <div className={styles.walletOption} onClick={handleDisconnect}>
          <span>
            <Trans id="disconnect" message="Disconnect" />
          </span>
        </div>
        <div className={styles.walletOption} onClick={handleChangeWallet}>
          <span>
            <Trans id="change_wallet" message="Change wallet" />
          </span>
        </div>
      </div>
    </div>
  );
}
